export default __webpack_public_path__ + "static/media/stimmex-festival-2026_sx desktop.12297466.png";